import { HttpClient } from "@angular/common/http";
import { Observable } from "../../../node_modules/rxjs";
import { Injectable } from "../../../node_modules/@angular/core";
import { AppSettings } from "../app.settings";

@Injectable()
export class DadataService{
    url:string = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest";
    headers:any = {
        Authorization:"Token "+AppSettings.ddataApiKey,
        "Content-Type":"application/json",
        Accept:"application/json"
    }

    constructor(private _http: HttpClient){}

    getFioSuggestions(query:string):Observable<any>{
        return this._http.post(this.url+"/fio",{query:query},{headers:this.headers}) as Observable<any>
    }
}